import { getProductFlowConfiguration } from '@flows/configs/shared/flowConfiguration'
import type { FlowConfigProps, StepConfigParams } from '@flows/configs/types'
import type { AnySteps } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'
import * as flowConfigUtils from '@flows/insurance/utils'

import { schema } from './schema'
import legal_birthday from './steps/legal_birthday'
import legal_claims_free from './steps/legal_claims_free'
import legal_coverage_options from './steps/legal_coverage_options'
import legal_criminal from './steps/legal_criminal'
import legal_damages from './steps/legal_damages'
import legal_employment_status from './steps/legal_employment_status'
import legal_insurance_cancellation_date from './steps/legal_insurance_cancellation_date'
import legal_insurance_cancelled_by from './steps/legal_insurance_cancelled_by'
import legal_partner_name from './steps/legal_partner_name'
import legal_previous_insurance_carrier from './steps/legal_previous_insurance_carrier'
import legal_previous_legal_insurance from './steps/legal_previous_legal_insurance'
import legal_tenant from './steps/legal_tenant'
import legal_zip from './steps/legal_zip'

const getLegalConfig = ({ clientHelpers, subFlow = SubFlow.LegalComfort3 }: FlowConfigProps) => {
  const productKey = 'legal_comfort_3_basic_roland_de'
  const stepParams = {
    productKey,
    clientHelpers,
    helperFunctions: flowConfigUtils.generateGetFlowValueFunctions(productKey),
    subFlow,
  } satisfies StepConfigParams

  return getProductFlowConfiguration(
    productKey,
    {
      legal_birthday: legal_birthday(stepParams),
      legal_zip: legal_zip(stepParams),
      legal_employment_status: legal_employment_status(stepParams),
      legal_previous_legal_insurance: legal_previous_legal_insurance(stepParams),
      legal_previous_insurance_carrier: legal_previous_insurance_carrier(stepParams),
      legal_damages: legal_damages(stepParams),
      legal_claims_free: legal_claims_free(stepParams),
      legal_insurance_cancelled_by: legal_insurance_cancelled_by(stepParams),
      legal_insurance_cancellation_date: legal_insurance_cancellation_date(stepParams),
      legal_tenant: legal_tenant(stepParams),
      legal_criminal: legal_criminal(stepParams),
      legal_coverage_options: legal_coverage_options(stepParams),
      legal_partner_name: legal_partner_name(stepParams),
    } as const satisfies AnySteps,
    {
      constants: {
        FIRST_STEP_NAME: 'legal_birthday',
        SCHEMA: schema,
      },
    }
  )
}

export default getLegalConfig
